import React from 'react';

import classes from './MuscleMultiplierAdditionalInfo.module.scss';
import { SCORING_RULE, ScoringRuleType } from '../../../../../constants/scoringRule';
import { getValueOrDash } from '../../../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';
import { getIsNullish } from '../../../../../../shared/utils/jsUtils';

type MuscleMultiplierAdditionalInfoProps = {
  scoringRuleType?: ScoringRuleType | null;
  muscleGainLbs: number | null;
  muscleGainMultiplier: number | null;
};

const MuscleMultiplierAdditionalInfo = ({
  scoringRuleType,
  muscleGainLbs,
  muscleGainMultiplier,
}: MuscleMultiplierAdditionalInfoProps) => {
  if (
    scoringRuleType !== SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING ||
    getIsNullish(muscleGainLbs) ||
    getIsNullish(muscleGainMultiplier)
  ) {
    return null;
  }

  return (
    <span className={classes.multiplierAdditionalInfo}>
      (*{getValueOrDash(muscleGainMultiplier)})
    </span>
  );
};

export { MuscleMultiplierAdditionalInfo };
